import { configPublic } from '@src/config.public'

const TBB = 'teambeachbody.com'
const BOD = 'beachbodyondemand.com'
const BB = 'beachbody.com'
const DEFAULT_ORIGIN = 'https://bodi.com'

export const isExternalBODiLink = (href: string) => {
  const url = new URL(href, globalThis.location?.origin ?? DEFAULT_ORIGIN)
  return [TBB, BB, BOD].some(
    (hostname) => url.hostname === hostname || url.hostname.endsWith(`.${hostname}`)
  )
}

export const transformExternalBODiLinkInText = (text: string) => {
  const tbbRegex = new RegExp(`https?://(?:www\\.)?${TBB}`, 'i')
  const bodRegex = new RegExp(`https?://(?:www\\.)?${BOD}`, 'i')
  const bbRegex = new RegExp(`https?://(?:www\\.)?${BB}`, 'i')

  return text
    .replace(tbbRegex, configPublic.general.tbbUrl)
    .replace(bodRegex, configPublic.general.bodUrl)
    .replace(bbRegex, configPublic.general.beachbodyUrl)
}

export const transformExternalBODiLink = (href: string) => {
  const tbbUrl = new URL(configPublic.general.tbbUrl)
  const bodUrl = new URL(configPublic.general.bodUrl)
  const beachbodyUrl = new URL(configPublic.general.beachbodyUrl)

  const url = new URL(href, globalThis.location?.origin ?? DEFAULT_ORIGIN)

  if (url.hostname === TBB || url.hostname.endsWith(`.${TBB}`) || url.hostname.includes('tbb')) {
    url.hostname = tbbUrl.hostname
  } else if (url.hostname === BOD || url.hostname.endsWith(`.${BOD}`)) {
    url.hostname = bodUrl.hostname
  } else if (url.hostname === BB || url.hostname.endsWith(`.${BB}`)) {
    url.hostname = beachbodyUrl.hostname
  }

  return url.toString()
}
